import React, { useRef, useState } from 'react';

import { AssetForEdit, DropdownSelectorType, Employee, TaskClosingCode, TaskStatusCoordinateDetails } from 'types/interfaces';

import { ApiResponse } from 'components/services/interfaces';
import ConfirmationDialog from 'ui/shared/ConfirmationDialog';
import DeleteConfirmationDialog from 'ui/shared/DeleteConfirmationDialog';

import AssetDialog from './AssetDialog';
import TaskCodeDialog from './TaskCodeDialog';
import TaskMapDialog from './TaskMapDialog';

interface TaskCardDialogsProps {
    showDialog: boolean;
    handleConfirmationCancel: () => void;
    handleConfirmationContinue: () => void;

    showEmployeesRecommendationDialog: boolean;
    dismissEmployeesRecommendationDialog: () => void;
    confirmEmployeesRecommendation: () => Promise<void>;
    recommendationDialogContext: 'save' | 'transition' | null;
    recommendedEmployeesCount: number | null;
    employees: Employee[];

    showDeleteDialog: boolean;
    setShowDeleteDialog: (value: React.SetStateAction<boolean>) => void;
    handleDeleteConfirmation: () => Promise<void>;
    name: string;
    assetCardKey: string;

    dialogVisible: boolean;
    assetData: any;
    onHideAssetCard: () => void;
    handleAdd: (asset: AssetForEdit) => Promise<ApiResponse<AssetForEdit>>;
    handleUpdate: (id: string | number, updatedAsset: AssetForEdit) => Promise<ApiResponse<AssetForEdit>>;
    closeAssetDialog: () => void;
    assetCardRef: React.MutableRefObject<{
    handleCancel: () => void;
} | null>;

    closeCodeDialogVisible: boolean;
    selectedAction: DropdownSelectorType | null;
    closingCodes: TaskClosingCode[];
    onHideTaskCodeCard: () => void;
    handleCodeDialogSave: (selectedCloseCode: TaskClosingCode) => Promise<void>;
    closeClosingCodesDialog: () => void ;
    saveDialog: () => void;
    taskCodeCardRef: React.RefObject<{
    handleCancel: () => void;
} | null>;

    mapDialogVisible: boolean;
    mapDialogLoading: boolean;
    mapDialogError: string | null;
    closeTaskMapDialog: () => void;
    mapTaskDetails: TaskStatusCoordinateDetails | null;
}


export function TaskCardDialogs(props: TaskCardDialogsProps) {

  const {
    showDialog,
    handleConfirmationCancel,
    handleConfirmationContinue,

    showEmployeesRecommendationDialog,
    dismissEmployeesRecommendationDialog,
    confirmEmployeesRecommendation,
    recommendationDialogContext,
    recommendedEmployeesCount,
    employees,

    showDeleteDialog,
    setShowDeleteDialog,
    handleDeleteConfirmation,
    name,
    assetCardKey,

    dialogVisible,
    assetData,
    onHideAssetCard,
    handleAdd,
    handleUpdate,
    closeAssetDialog,
    assetCardRef,

    closeCodeDialogVisible,
    selectedAction,
    closingCodes,
    onHideTaskCodeCard,
    handleCodeDialogSave,
    closeClosingCodesDialog,
    saveDialog,
    taskCodeCardRef,

    mapDialogVisible,
    mapDialogLoading,
    closeTaskMapDialog,
    mapTaskDetails,
    mapDialogError

  } = props

  return (
    <>
      <ConfirmationDialog
        visible={showDialog}
        onCancel={handleConfirmationCancel}
        onContinue={handleConfirmationContinue}
      />
      <ConfirmationDialog
        visible={showEmployeesRecommendationDialog}
        onHide={dismissEmployeesRecommendationDialog}
        onCancel={dismissEmployeesRecommendationDialog}
        onContinue={confirmEmployeesRecommendation}
        header="Предупреждение по составу исполнителей"
        confirmLabel={
          recommendationDialogContext === 'transition'
            ? 'Подтвердить и продолжить'
            : 'Сохранить с текущим составом'
        }
        cancelLabel="Скорректировать состав исполнителей"
        message={`Рекомендованное количество исполнителей для выбранного типа наряда: ${
          recommendedEmployeesCount ?? 0
        }. Текущее количество: ${
          Array.isArray(employees) ? employees.length : 0
        }. ${
          recommendationDialogContext === 'transition'
            ? 'При отказе переход этапа не будет выполнен.'
            : ''
        }`}
      />

      <DeleteConfirmationDialog
        visible={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
        onConfirm={handleDeleteConfirmation}
        entityType="наряд"
        entityName={name}
      />

      <AssetDialog
        assetCardKey={assetCardKey}
        dialogVisible={dialogVisible}
        assetData={assetData}
        onHideAssetCard={onHideAssetCard}
        handleAdd={handleAdd}
        handleUpdate={handleUpdate}
        closeDialog={closeAssetDialog}
        ref={assetCardRef}
      />

      <TaskCodeDialog
        closeCodeDialogVisible={closeCodeDialogVisible}
        selectedAction={selectedAction}
        closingCodes={closingCodes}
        onHidetaskCodeCard={onHideTaskCodeCard}
        handleCodeDialogSave={handleCodeDialogSave}
        closeDialog={closeClosingCodesDialog}
        saveDialog={saveDialog}
        ref={taskCodeCardRef}
      />
      <TaskMapDialog
        visible={mapDialogVisible}
        loading={mapDialogLoading}
        error={mapDialogError}
        onHide={closeTaskMapDialog}
        taskDetails={mapTaskDetails}
      />
    </>
  )

}
